import $ from 'sbf-design-system/js/jquery';
import '../application';
import Overlay from 'sbf-design-system-component/overlays/overlay';
import banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/forms/base';

const privateEventOverlay = new Overlay($('#privateEventOverlay'), {
  full_screen: true
});

const $eventsList = $('.community--event-list');
const $privateEventOverlayConfirm = $('#privateEventOverlay').find('.private-event-join');
const $privateEventOverlayCancel = $('#privateEventOverlay').find('.cancel');
const $sortEventListSelector = $('#sort-event-list');
let radiusSearchError = false;

$('#community--radius-search').on('submit', function () {
  const zip = $(this).find('input').val();

  if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(zip)) {
    window.location = `/search?location=${zip}&radius=50&type=e&sort-by=total_donations&order=desc`;
  } else {
    banner.showError('Please enter a valid zip code (e.g. 10001)', true);
    radiusSearchError = true;
  }

  return false;
});

$('#radiusZip').on('keydown', function () {
  if (radiusSearchError) {
    banner.close();
    radiusSearchError = false;
  }
});

$eventsList.on('click', '.private-event', function (click) {
  click.preventDefault();
  $privateEventOverlayConfirm.attr('href', $(this).attr('href'));
  privateEventOverlay.show();
});

$privateEventOverlayCancel.on('click', function (click) {
  click.preventDefault();
  privateEventOverlay.hide();
});

$sortEventListSelector.on('change', function (change) {
  const sortBy = $(this).val();

  // get the URL of the page minus the querystring
  let url = window.location.href.replace(/\?.+$/, '');
  // add sort by parameters to the url based on the user's input from the dropdown
  url += `?sort_by=${sortBy}`;
  window.location.href = url;
});

function getUrlParams () {
  const paramsList = [];
  let param;

  const url = window.location.href;
  const params = url.replace(/^[^?]*\?([^#]*)#?.*$/, '$1').split('&');

  for (let i = 0; i < params.length; i++) {
    param = params[i].split('=');
    paramsList.push(param[0]);
    paramsList[param[0]] = param[1];
  }
  return paramsList;
}
const $urlParams = getUrlParams();

if ($urlParams.sort_by === 'date') {
  $('.community--event-list').addClass('no-rank');
}

function setDropdown () {
  if ($urlParams.sort_by !== undefined) {
    const dropdownValue = $urlParams.sort_by;
    $('#sort-event-list [value="default"]').prop('selected', false); // iphone ipad bug fix
    $(`#sort-event-list [value=${dropdownValue}]`).prop('selected', true);
  } else {
    $('#sort-event-list [value="default"]').prop('selected', true);
  }
}
setDropdown();

let rank = 1;
let last = Number.MAX_VALUE;

$('.community--event').each((index, event) => {
  const $event = $(event);
  let amt;

  if ($urlParams.sort_by === 'date') {
    amt = '';
  } else if ($urlParams.sort_by === 'participant') {
    amt = Number($event.find('.participants').text().replace(/[^0-9.]+/g, ''));
  } else {
    amt = Number($event.find('.amount-raised').text().replace(/[^0-9.]+/g, ''));
  }

  if (amt !== last) {
    rank = index + 1;
  }
  last = amt;
  $event.find('.event-rank').text(rank);
});

$('#viewMoreEvents').click(function () {
  $('.community--event-list').addClass('show-all');

  if ($('.community--event-list li').length === $('.community--event-list li:visible').length) {
    $('#viewMoreEvents').hide();
  }
});

// Assign event handlers for private event tooltip buttons.
$('.private-event-tooltip-button').each(function () {
  // Button - mouse enter event.
  $(this).unbind('mouseenter').bind('mouseenter', function () {
    const $this = $(this);
    const $popup = $('.private-event-tooltip-popup');
    if ($popup.length) {
      const buttonOffset = $this.offset();
      const buttonHeight = $this.height();
      const popupWidth = $popup.width();
      const popupHeight = $popup.height();
      const popupPadding = parseInt($popup.css('padding'));
      $popup.css({
        display: 'block',
        top: buttonOffset.top - popupHeight - (popupPadding * 2) - buttonHeight,
        left: buttonOffset.left - parseInt(popupWidth / 2)
      });
    }
  });
  // Button - mouse leave event.
  $(this).unbind('mouseleave').bind('mouseleave', function () {
    $('.private-event-tooltip-popup').css('display', 'none');
  });
});
